import { useEffect, useCallback } from 'react';
import useApi from './useApi';
import { CoatingItem } from '../types/CoatingTypes';
import { useAppSettings } from '../hooks/useAppSettings';

export default () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getCoatings = useCallback(async () => {
        try {
            const apiUrl = appSettings?.api;
            if (!apiUrl) {
                throw new Error('API URL not configured in app settings');
            }
            await getApiData({
                endpoint: `${apiUrl}/GetCoatings`,
            });
        } catch (error) {
            console.error('Failed to fetch coatings:', error);
        }
    }, [getApiData]);

    useEffect(() => {
        if (state.status === 'success' && state.result) {
            try {
                console.log('Coatings API Response:', state.result);
                console.log('Coatings API Response type:', typeof state.result);
                console.log('Is array?', Array.isArray(state.result));
            } catch (error) {
                console.error('Error processing coatings:', error);
            }
        }
    }, [state.status, state.result]);

    // Get the coatings data
    const getCoatingsData = (): CoatingItem[] => {
        if (state.status === 'success' && state.result) {
            let rawCoatings: any[] = [];
            if (Array.isArray(state.result)) {
                rawCoatings = state.result;
            } else if (state.result.data && Array.isArray(state.result.data)) {
                rawCoatings = state.result.data;
            } else if (typeof state.result === 'object') {
                rawCoatings = [state.result];
            }
            return rawCoatings;
        }
        return [];
    };

    return {
        coatings: getCoatingsData(),
        loading: state.isLoading,
        error: state.error,
        getCoatings,
        status: state.status,
    };
};
